module.exports = __webpack_public_path__ + "img/people.a9587f6b.jpg";